import { lastOrDefault } from './array.helper';

/**
 * Checks if a path is an HTTP URL.
 * @function isHttp
 * @param {string} path - The path to check.
 * @returns {boolean} True if the path is an HTTP URL, false otherwise.
 */
const isHttp = (path: string) => path && path.startsWith('http');

/**
 * Resolves an IPFS or HTTP path to a full HTTP URL.
 * @function resolveHttpPath
 * @param {string} path - The IPFS or HTTP path to resolve.
 * @param {string} [baseIpfsUrl] - The base IPFS gateway URL.
 * @returns {string | undefined} The resolved HTTP URL or undefined if the path is invalid.
 */
export const resolveHttpPath = (path: string, baseIpfsUrl?: string) => {
  baseIpfsUrl = baseIpfsUrl || process.env.NEXT_PUBLIC_IPFS_GATEWAY;

  if (!path) return undefined;

  if (path.includes('/ipfs/')) {
    return `${baseIpfsUrl}/${lastOrDefault(path.split('/ipfs/'))}`;
  }

  if (isHttp(path)) {
    return path;
  }

  if (path.startsWith('ipfs://')) {
    return `${baseIpfsUrl}/${lastOrDefault(path.split('ipfs://'))}`;
  }

  if (path.endsWith('ipfs.dweb.link')) {
    return `${baseIpfsUrl}/${lastOrDefault(
      path.replace('.ipfs.dweb.link', '').split('//'),
    )}`;
  }

  return undefined;
};
